<template>
  <div class="app-container">
    <!-- <el-select v-model="listQuery.role" :placeholder="'role'" style="width: 90px" class="filter-item" @change="handleFilter">
      <el-option v-for="item in roleOpitons" :key="item.value" :label="item.label" :value="item.value" />
    </el-select> -->
    <el-table v-loading="listLoading" :data="list" fit highlight-current-row style="width: 100%">
      <el-table-column align="center" label="編號" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.number }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="姓名" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="剩餘點數" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.credits }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250">
        <template slot-scope="scope">
          <el-button type="success" size="small" @click="record(scope.row.number, scope.row.name, scope.row.credits, scope.row.orders)">點數歷程</el-button>
          <el-button type="success" size="small" @click="edit(scope.row.id, scope.row.name)">會員點數調整</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />
    <RecordDialog :dialog-record-visible-prop="dialogRecordVisible" />
    <EditDialog :dialog-edit-visible-prop="dialogEditVisible" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import RecordDialog from '@/views/billings/credit/record'
import EditDialog from '@/views/billings/credit/edit'
import BillingResource from '@/api/billing'
const billingResource = new BillingResource()
export default {
  name: 'MemberCreditList',
  components: { Pagination, RecordDialog, EditDialog },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        role: 'student'
      },
      dialogRecordVisible: false,
      dialogEditVisible: false,
      roleOpitons: [
        { 'value': 'all', 'label': '全部' },
        { 'value': 'teacher', 'label': '老師' },
        { 'value': 'student', 'label': '學生' }
      ],
      currentRecordNumber: '',
      currentRecordName: '',
      currentRecordCredits: 0,
      currentRecordItem: null,
      currentEditId: 0,
      currentEditName: '',
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        12: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 12)' },
        13: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 13)' },
        23: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again. (Error Code 23)' }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.listLoading = true
      const { data } = await billingResource.getCourseMemberList(this.listQuery)
      this.list = data.items
      this.total = data.total
      this.countries = data.countries
      this.listLoading = false
    },
    record(number, name, credits, item) {
      this.currentRecordNumber = number
      this.currentRecordName = name
      this.currentRecordCredits = credits
      this.currentRecordItem = item
      this.dialogRecordVisible = true
    },
    edit(userId, userName) {
      this.currentEditName = userName
      this.currentEditId = userId
      this.dialogEditVisible = true
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.el-table {
  position: inherit!important;
}
</style>
